import axios from 'axios';


const list = (id, params) => axios.get(`/produtos/${id}/estoque`, {
  params,
});

export default {
  list,
};
